<template>
  <div>
    <div class="campaign-image" v-show="src" :style="
          'height:' +
            height +
            'px'">
       <img ref="image" :src="src" style="display: none;" lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg==" />
      <canvas ref="canvas" class="img-fluid"></canvas>
    </div>
    <div v-show="!src" :style="
          'height:' +
            height +
            'px'">
      <v-img :src="src" :aspect-ratio="aspectRatio" lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg=="></v-img>
    </div>
  </div>
</template>

<script>
// import { getPosterDimensions } from '@/constants/poster-dimensions'
const fontSize = 40
const px = 12
const py = 2
const mx = 34
const my = 14
export default {
  props: {
    src: {
      required: true
    },
    height: {
      type: [Number, String],
      default: undefined
    },
    promotionType: {
      required: true,
      type: Number
    },
   aspectRatio: {
      type: [Number, String],
      default: undefined
    },
    config: {
      type: Object
    }
  },
  data () {
    return {
      canvas: null,
      ctx: null,
      image: null
    }
  },
  computed: {
  },
  watch: {
    config: {
      deep: true,
      handler () {
        this.drawImage()
      }
    }
  },
  methods: {
    initImageOnload () {
      this.image = this.$refs.image
      if (this.image) {
        this.image.onload = () => {
          this.initCanvas()
          this.drawImage()
        }
      }
    },
    initCanvas () {
      if (this.$refs.canvas) {
        this.canvas = this.$refs.canvas
        this.canvas.width = this.image.width
        this.canvas.height = this.image.height
        this.ctx = this.canvas.getContext('2d')
      }
    },
    drawImage () {
      if (this.ctx) {
        // Draw image without text
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        this.ctx.drawImage(this.image, 0, 0)

        // Set text props and draw text
        if (this.config && this.config.textConfig) {
          // ctx props
          this.ctx.font = `${fontSize}px Niveau Grotesk`
          this.ctx.fillStyle = this.config.textConfig.textColor || 'white'
          this.ctx.textAlign = this.getTextAlignment(this.config.textConfig.hPos)

          // text calculations
          let lineHeight = fontSize * 1.5
          let spacingX = 2 * (mx + px)
          let mw = Math.round(this.canvas.width * (2 / 3)) - spacingX
          let lineCount = this.getLineCount(this.ctx, this.config.textConfig.text, mw)
          let x = this.getX(this.config.textConfig.hPos)
          let y = this.getY(this.config.textConfig.vPos, lineCount)
          this.drawText(this.ctx, this.config.textConfig.text, x, y, mw, lineHeight, lineCount)
        }
      }
    },
    drawText (context, text, x, y, maxWidth, lineHeight, lineCount) {
      if (lineCount > 1) {
        this.drawTextMulti(context, text, x, y, maxWidth, lineHeight)
      } else {
        this.drawTextSingle(context, text, x, y)
      }
    },
    drawTextSingle (context, text, x, y) {
      context.fillText(text, x, y)
    },
    drawTextMulti (context, text, x, y, maxWidth, lineHeight) {
      let words = text.split(' ')
      let line = ''
      for (var n = 0; n < words.length; n++) {
        var testLine = line + words[n] + ' '
        var metrics = context.measureText(testLine)
        var testWidth = metrics.width
        if (testWidth > maxWidth && n > 0) {
          context.fillText(line, x, y)
          line = words[n] + ' '
          y += lineHeight
        } else {
          line = testLine
        }
      }
      context.fillText(line, x, y)
    },
    getLineCount (context, text, maxWidth) {
      let words = text.split(' ')
      let line = ''
      let numberOfLines = 1
      for (var n = 0; n < words.length; n++) {
        var testLine = line + words[n] + ' '
        var metrics = context.measureText(testLine)
        var testWidth = metrics.width
        if (testWidth > maxWidth && n > 0) {
          line = words[n] + ' '
          numberOfLines++
        } else {
          line = testLine
        }
      }
      return numberOfLines
    },
    getX (hPos, maxWidth) {
      switch (hPos) {
        case 0:
          return 0 + px + mx
        case 1:
          return this.canvas.width / 2
        case 2:
          return this.canvas.width - px - mx
        default:
          return 0
      }
    },
    getY (yPos, lines) {
      switch (yPos) {
        case 0:
          return fontSize + py + my
        case 1:
          return this.canvas.height / 2
        case 2:
          return this.canvas.height - (fontSize * lines) - py - my
        default:
          return fontSize + py + my
      }
    },
    getTextAlignment (hPos) {
      switch (hPos) {
        case 0:
          return 'left'
        case 1:
          return 'center'
        case 2:
          return 'right'
        default:
          return 'left'
      }
    }
  },
  mounted () {
    this.initImageOnload()
  }
}
</script>
<style lang="scss" scoped>
.campaign-image {
  position: relative;
  display: block;
}
.img-fluid {
  display: block;
  width: 100%;
  height: 100%;
}

</style>
